import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export default function WorkoutBackHeader({ title, subtitle, action, fallback = '/workout' }) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1)
    else navigate(fallback)
  }

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={handleBack}
        aria-label="Back"
        className="p-2 -ms-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
      >
        <ArrowLeft className="w-5 h-5 rtl:-scale-x-100" />
      </button>
      <div className="flex-1 min-w-0">
        <h1 className="text-xl sm:text-2xl font-bold text-foreground truncate">{title}</h1>
        {subtitle && (
          <p className="text-xs sm:text-sm text-muted-foreground truncate">{subtitle}</p>
        )}
      </div>
      {action}
    </div>
  )
}
